// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"225":"3f32f989","229":"d7593348","508":"e709c3b0","611":"8722f694","633":"a65c8e7a","640":"b05d89f0","656":"d7e47c43","667":"5ae7cf9a","934":"53bcf8ee"}[chunkId] + ".chunk.js";
};